// extracted by mini-css-extract-plugin
module.exports =  {"details":"details-EuHwi","placeholder":"placeholder-Kigxt"};